module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"download":"下载App","wx":"微信扫码打开小程序","support":"支持Android&iOS","desc":"随时随地查看个人文件"},"en":{"download":"Download APP","wx":"Scan the WeChat code to open the mini program","support":"Support Android & iOS","desc":"View personal files anytime, anywhere"}}')
  delete Component.options._Ctor
}
